import { Container, Flex, Icon, Text } from "@chakra-ui/react";
import { Breadcrumb, Checkbox, Input, PreviousButton } from "components";
import { Heading } from "elements";
import { routes } from "utils";
import { BookDetailsTile } from "./BookDetailsTile";
import { RiVisaLine } from 'react-icons/ri';
import { SiMastercard } from 'react-icons/si';
import { CheckIcon, DeleteIcon } from "@chakra-ui/icons";
import { ChangeEvent } from "react";
import { BookingStepsLabels } from "utils/enums";
import { ReactElement } from "react-markdown/lib/react-markdown";
import { BsCreditCard2BackFill } from "react-icons/bs";
import { InputProps } from "components/Input/Input";

const CardFormWrapper = ({ children }: { children: ReactElement[]; }) =>
(<Flex flexDirection='column'
  border="1px solid #E9EEF1"
  marginBottom={10}
  padding={[4, 6, 8, 10]}
  borderRadius={[20, 30, 50]}>
  {children}
</Flex>);

const CardFormHeader = ({ iconPre, title, iconPost }: { iconPre?: ReactElement, title: string, iconPost: ReactElement; }) => (
  <Flex
    padding={[2, 4, 8, 10]}
    justifyContent='space-between'>
    <Flex align='center' justifyContent='flex-start' gap={[2]}>
      {iconPre}
      <Text fontWeight={600} fontSize="20px" fontFamily="Montserrat">
        {title}
      </Text>
    </Flex>
    <Flex align='center' gap={5}>
      {iconPost}
    </Flex>
  </Flex>
);

const FilledInput = (
  { placeholder, variant = 'filled' }:
    { placeholder: string, variant?: InputProps['variant']; }) =>
  (<Input padding={[4, 8]} variant={variant} placeholder={placeholder} />);

const PaymentDetails = () => {

  return (
    <>
      <PreviousButton />
      <Container marginTop={5} marginLeft={0} marginBottom={5} paddingLeft={0}>
        <Heading title="Payment" color="#1F1E1E" fontWeight={700} />
      </Container>
      <Breadcrumb color="#1F1E1E" linkList={[
        { link: routes.BOOKING.HOW_TO_PAY, title: BookingStepsLabels.STEP_1 },
        { link: routes.BOOKING.PAYMENT_METHOD, title: BookingStepsLabels.STEP_2 },
        { link: '', title: BookingStepsLabels.STEP_3 }]} />
      <Container marginTop={50} marginLeft={0} marginBottom={5} paddingLeft={0}>
        <Heading fontSize="32px" title="3. Details" color="#3498FE" fontWeight={700} />
      </Container>

      <Flex flexDirection={['column', 'column', 'column', 'row']} justifyContent='space-between' gap={[10]}>
        <Flex flexDirection='column' width={['100%']}>

          {/* First  */}
          <CardFormWrapper>
            <CardFormHeader
              iconPre={<CheckIcon w={6} h={6} />}
              title='Add new card'
              iconPost={<>
                <Icon as={SiMastercard} w={8} h={8} />
                <Icon as={RiVisaLine} w={8} h={8} />
              </>}
            />

            <Flex gap={[5]} flexDirection='column'>
              <FilledInput placeholder="Card number" />
              <FilledInput placeholder="Card owner" />

              <Flex gap={[5]} justifyContent='space-between'>
                <FilledInput placeholder="Expiry date" />
                <FilledInput placeholder="CVC" />
              </Flex>
            </Flex>

          </CardFormWrapper>

          <Flex justifyContent='flex-end' marginBottom={5}
            gap={[4]} align='center' >
            <Checkbox onChange={function (event: ChangeEvent<HTMLInputElement>): void {
              throw new Error("Function not implemented.");
            }} />
            <Text fontWeight={400} fontSize="16px" fontFamily="Montserrat">Set us default</Text>
          </Flex>

          {/* Second  */}

          <CardFormWrapper>
            <CardFormHeader
              iconPre={<Icon as={BsCreditCard2BackFill} w={8} h={8} />}
              title='Registered cards'
              iconPost={<Icon as={RiVisaLine} w={8} h={8} />}
            />

            <Flex gap={[5]} flexDirection='column'>
              <FilledInput placeholder="Card number" />
              <FilledInput placeholder="Card owner" />

              <Flex gap={[5]} justifyContent='space-between'>
                <FilledInput placeholder="Expiry date" />
                <FilledInput placeholder="CVC" />
              </Flex>
            </Flex>

          </CardFormWrapper>

          <Flex justifyContent='flex-end' marginBottom={5}
            gap={[4]} align='center' >
            <DeleteIcon />
            <Text fontWeight={400} fontSize="16px" fontFamily="Montserrat">Delete registered card</Text>
          </Flex>
        </Flex>

        <BookDetailsTile price={300} nights={5}
          type="Stays" title="Bucharest" numberOfReviews={20} rating={5} url={routes.BOOKING.DETAILS} image="https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg" housekeepingFee={0} platformFee={0} parkingFee={5} />
      </Flex>
    </>
  );
};

export { PaymentDetails };
